<script setup>
// Edits one recipient before the send. Edits are local to the campaign — HubSpot is not
// written back, so fixing a phone here does not silently mutate the CRM.
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/ui/Dialog.vue';
import DialogHeader from 'dashboard/components-next/ui/DialogHeader.vue';
import DialogTitle from 'dashboard/components-next/ui/DialogTitle.vue';
import Input from 'dashboard/components-next/ui/Input.vue';
import Button from 'dashboard/components-next/ui/Button.vue';

const props = defineProps({
  open: { type: Boolean, default: false },
  contact: { type: Object, default: null },
});

const emit = defineEmits(['update:open', 'save']);

const { t } = useI18n();
const form = ref({
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  company: '',
});

watch(
  () => props.contact,
  contact => {
    form.value = {
      first_name: contact?.first_name || '',
      last_name: contact?.last_name || '',
      email: contact?.email || '',
      phone: contact?.phone || '',
      company: contact?.company || '',
    };
  },
  { immediate: true }
);

function save() {
  emit('save', { ...props.contact, ...form.value });
  emit('update:open', false);
}
</script>

<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogHeader>
      <DialogTitle>{{ t('OUTBOUNDS.CONTACT_DIALOG.TITLE') }}</DialogTitle>
    </DialogHeader>

    <div class="grid grid-cols-2 gap-3 mt-4">
      <label class="flex flex-col gap-1 text-xs text-n-slate-11">
        {{ t('OUTBOUNDS.CONTACTS.FIRST_NAME') }}
        <Input v-model="form.first_name" />
      </label>
      <label class="flex flex-col gap-1 text-xs text-n-slate-11">
        {{ t('OUTBOUNDS.CONTACTS.LAST_NAME') }}
        <Input v-model="form.last_name" />
      </label>
      <label class="flex flex-col col-span-2 gap-1 text-xs text-n-slate-11">
        {{ t('OUTBOUNDS.CONTACTS.PHONE') }}
        <Input v-model="form.phone" placeholder="+55 11 90000-0000" />
      </label>
      <label class="flex flex-col col-span-2 gap-1 text-xs text-n-slate-11">
        {{ t('OUTBOUNDS.CONTACTS.EMAIL') }}
        <Input v-model="form.email" type="email" />
      </label>
      <label class="flex flex-col col-span-2 gap-1 text-xs text-n-slate-11">
        {{ t('OUTBOUNDS.CONTACTS.COMPANY') }}
        <Input v-model="form.company" />
      </label>
    </div>

    <div class="flex justify-end gap-2 mt-5">
      <Button variant="ghost" @click="emit('update:open', false)">
        {{ t('OUTBOUNDS.CANCEL') }}
      </Button>
      <Button @click="save">{{ t('OUTBOUNDS.SAVE') }}</Button>
    </div>
  </Dialog>
</template>
